<template>
<div>
  <div class="content">
    <div class="vehicle-list">
      <div v-for="item in cheguaList" :key="item.id">
        <div class="vehicle-item" >
          <div class="vehicle-item-content">

            <div class="bpm-status" v-if="item.bpmStatus == 1">
              <van-tag type="danger">未提交</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.bpmStatus == 2">
              <van-tag type="warning">待审核</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.bpmStatus == 3">
              <van-tag type="primary">审核成功</van-tag>
            </div>

            <div class="vehicle-name">车挂号:{{item.cheguahao}}</div>
            <div class="content-item first-item">所属车队:{{item.sscd?item.sscd:"请编辑补充"}}</div>
            <div class="content-item">车辆证件用途:{{item.vehicleUsageName}}</div>
            <div class="content-item">行驶证有效期:{{item.xingshizhengyxq?item.xingshizhengyxq:"请编辑补充"}}</div>
          </div>
          <div class="btns-box" v-if="item.bpmStatus == 1">
            <van-button type="info" class="btn-op" @click="submitVehicle(item.id)">提交审核</van-button>
            <van-button type="primary"  class="btn-op" :to="{name: 'cheguaDetail',params: {id: item.id}}">查看</van-button>
            <van-button type="warning"  class="btn-op"  @click="editBeian(item.id,item.bpmStatus)" >编辑</van-button>
          </div>
          <div class="btns-box" v-if="item.bpmStatus == 2 || item.bpmStatus == 3">
            <van-button type="primary"  class="btn-op2" :to="{name: 'cheguaDetail',params: {id: item.id}}">查看</van-button>
            <van-button type="warning"  class="btn-op2"  @click="editBeian(item.id,item.bpmStatus)" >编辑</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="add-driver-box">
    <div class="back-step2">
      <van-button round block type="default" class="backBtn2" :to="{name:'mine'}" >返回</van-button>
    </div>
  </div>
  <Tabbar></Tabbar>

</div>
</template>

<script>
import {
  Dialog,
  Toast
} from 'vant'
import api from '@/fetch/api'
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar,
  },
  inject: ['reload'],
  data() {
    return {
      cheguaList: [],
      active: this.$route.params.type ? this.$route.params.type : 0,
      actionShow: false,
      actions: [{
        name: '查看'
      }, {
        name: '编辑'
      }],
      actionId: 0,
      bpmStatus: 1,
    }

  },
  created: function() {
    document.title = "车挂信息管理";
    var that = this;
    var openid = this.$store.state.wx_info.openid;
    that.getUsage(openid);
  },
  methods: {
    getUsage(openid)
    {
      var that = this;
      var typeGroupName = "vehicleUsage";
      api.getTypeList(typeGroupName).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.success == true) {
          var result = resData.obj;
          that.resultList = result;
          that.getCheguaList(openid,result);
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function() {
        //
      });
    },

    getCheguaList(openid,resultList) {
      var that = this;
      api.getCheguaList(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var cheguaList = resData.data
          
          cheguaList.forEach((item) => {
            resultList.forEach((item2) => {
              
              if(item.vehicleUsage == item2.typecode)
              {
                item.vehicleUsageName = item2.typename;
              }
            });
          });

          that.cheguaList = cheguaList;

        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'vehicle'
            })
          });
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');

      });
    },
    // chooseActions(id, bpmStatus, choseType) {
    //   var that = this;
    //   that.$data.actionId = id;
    //   that.$data.bpmStatus = bpmStatus;
    //   that.$data.choseType = choseType;
    //   if (bpmStatus == "1") {
    //     that.$data.actions = [{
    //       name: '查看'
    //     }, {
    //       name: '编辑'
    //     }, {
    //       name: '提交审核'
    //     }];
    //   } else if (bpmStatus == "2") {
    //     that.$data.actions = [{
    //       name: '查看'
    //     }, {
    //       name: '编辑'
    //     }];
    //   } else {
    //     that.$data.actions = [{
    //       name: '查看'
    //     }, {
    //       name: '编辑'
    //     }];
    //   }
    //   this.actionShow = true;
    // },
    submitVehicle(actionId) {
      var that = this;
      if (actionId) {
        let formData = new FormData();
        formData.append("id", actionId);
        Dialog.confirm({
            message: '是否确认提交审核',
          })
          .then(() => {
            api.submitBeianChegua(formData).then(function(res) {
              var resData = JSON.parse(res);
              var resMessage = "";
              if (resData.respCode == "0") {
                resMessage = '操作成功';
              } else {
                resMessage = resData.message;
              }

              Dialog.alert({
                message: resMessage,
              }).then(() => {
                that.reload();
              });
            }).catch(function() {
              Toast.fail('连接失败，请刷新页面');
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },

    editBeian(actionId,bpmStatus){
      var that = this;
      if (bpmStatus == 3) {
        Dialog.confirm({
            message: '该车挂信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
          })
          .then(() => {
            // on confirm
            that.$router.push({
              name: 'editChegua',
              params: {
                id: actionId
              }
            })
          })
          .catch(() => {
            // on cancel
          });
      } else {
        that.$router.push({
          name: 'editChegua',
          params: {
            id: actionId
          }
        });
      }
    },
    // onSelect(item) {
    //   var that = this;
    //   var actionId = that.$data.actionId;
    //   var choseType = that.$data.choseType;
    //   var bpmStatus = that.$data.bpmStatus;
    //   if (actionId && choseType) {
    //     switch (item.name) {
    //       case '编辑':
    //         if (bpmStatus == 3) {
    //           Dialog.confirm({
    //               message: '该车挂信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
    //             })
    //             .then(() => {
    //               // on confirm
    //               that.$router.push({
    //                 name: 'editChegua',
    //                 params: {
    //                   id: actionId
    //                 }
    //               })
    //             })
    //             .catch(() => {
    //               // on cancel
    //             });
    //         } else {
    //           that.$router.push({
    //             name: 'editChegua',
    //             params: {
    //               id: actionId
    //             }
    //           });
    //         }
    //         break;
    //
    //       case '提交审核':
    //         that.submitVehicle(actionId, choseType)
    //         break;
    //       case '查看':
    //         that.$router.push({
    //           name: 'cheguaDetail',
    //           params: {
    //             id: actionId
    //           }
    //         });
    //         break;
    //     }
    //   } else {
    //     Toast('网络异常');
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: 1rem;
}
.add-chetou-box {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
}
.add-gua-box {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
}

.vehicle-list {
    margin-bottom: 4.75rem;
    .vehicle-item {
        margin: 1rem 1rem 0;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .vehicle-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .vehicle-name {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }
            .first-item {
                margin-top: 0.625rem;
            }
        }
        .vehicle-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
        .btns-box{
          .btn-op{
            width: 33.3%;
          }
          .btn-op2
          {
            width: 50%;
          }
        }
    }
}
.bpm-status {
    float: right;
}

.add-driver-box {
    position: fixed;
    bottom: 3.75rem;
    width: 100%;
    padding-bottom: env(safe-area-inset-bottom);
    .back-step2 {
        .backBtn2 {
            width: 90%;
            margin: 0 auto;
        }
    }
}
</style>
